import StatusButton from "../../../Component/Common/StatusButton";
import ViewButton from "../../../Component/Common/ViewButton";
import Badge from "../../../Component/RetUserComponents/Badge";

export function UserCard({ user, onView, onToggle, loading, isRetailerMobile }) {
  const isActive = user.status === 1;

  return (
    <div
      className={`rounded-2xl p-4 space-y-3 transition-all duration-300
        ${
          isRetailerMobile
            ? "bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
            : "border bg-white shadow-lg"
        }`}
    >
      
      {/* TOP ROW */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          
          {/* Avatar */}
          <div className={`w-12 h-12 rounded-full flex items-center justify-center text-lg font-semibold
                ${
                  isRetailerMobile
                    ? "bg-white/20 backdrop-blur-md text-black"
                    : "bg-slate-100 text-slate-600"
                }`}>
            {user.business_name?.charAt(0)?.toUpperCase() || "U"}
          </div>

          {/* Name + Role */}
          <div>
            <p className={`font-semibold leading-tight
                ${isRetailerMobile ? "text-black" : "text-slate-900"}
              `}>
              {user.business_name}
            </p>
            <p className={`text-xs
              ${isRetailerMobile ? "text-black/70" : "text-slate-500"}
            `}>
              {user.company_code}
            </p>
          </div>
        </div>

        {/* Status Badge */}
        <Badge color={isActive ? "blue" : "red"}>
          {isActive ? "Active" : "Inactive"}
        </Badge>
      </div>

      {/* INFO */}
      <div className="text-xs text-slate-700 space-y-1 pl-14">
        <p>
          <span className="font-medium">Mobile:</span>{" "}
          {user.contact_phone || "-"}
        </p>
        <p>
          <span className="font-medium">Email:</span>{" "}
          {user.contact_email || "-"}
        </p>
      </div>

      {/* ACTIONS */}
      <div className="flex justify-end gap-2 pt-2">
        <ViewButton size="sm" onClick={() => onView(user)} />

        {/* <StatusButton
          size="sm"
          label={loading ? "Updating..." : isActive ? "Deactivate" : "Activate"}
          disabled={loading}
          onClick={() => onToggle(user)}
          className={isActive ? "text-red-600" : "text-green-600"}
        /> */}
      </div>
    </div>
  );
}




// import StatusButton from "../../../Component/Common/StatusButton";
// import ViewButton from "../../../Component/Common/ViewButton";
// import Badge from "../../../Component/RetUserComponents/Badge";


// export function UserCard({ user, onView, onToggle, loading }) {
//   const isActive = user.status === 1;

//   return (
//     <div className="rounded-xl border bg-white p-4 shadow-sm space-y-3">
//       {/* Header */}
//       <div className="flex justify-between items-start">
//         <div>
//           <p className="font-medium text-slate-900">
//             {user.business_name}
//           </p>
//           <p className="text-xs text-slate-500">
//             ID: {user.id}
//           </p>
//         </div>

//        <Badge color={isActive ? "blue" : "red"}>
//             {isActive ? "Active" : "Inactive"}
//         </Badge>

//       </div>

//       {/* Details */}
//       <div className="text-xs text-slate-700 space-y-1">
//         <p><span className="font-medium">Mobile:</span> {user.contact_phone || "-"}</p>
//         <p><span className="font-medium">Email:</span> {user.contact_email || "-"}</p>
//         <p><span className="font-medium">Role:</span> Retailer User</p>
//         <p className="text-xs text-slate-500">
//           Created: {new Date(user.created_at).toLocaleDateString()}
//         </p>
//       </div>

//       {/* Actions */}
//       <div className="flex justify-end gap-2 pt-2">
//         <ViewButton size="sm" onClick={() => onView(user)} />

//         <StatusButton
//           size="sm"
//           label={loading ? "Updating..." : isActive ? "Deactivate" : "Activate"}
//           disabled={loading}
//           onClick={() => onToggle(user)}
//           className={isActive ? "text-red-600" : "text-green-600"}
//         />
//       </div>
//     </div>
//   );
// }